export enum FilePurpose {
  USER_AVATAR = 'user_avatar',
  PROPERTY_PHOTO = 'property_photo',
  AGENT_PROFESSIONAL_DOC = 'agent_professional_doc',
  PROPERTY_OWNERSHIP_DOC = 'property_ownership_doc',
}
